// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsPageStyles } from "@ces/Overrides/Pages/ProductDetailsPage";
import { layoutContainer, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

productDetailsPageStyles.breadcrumb = {
    css: css`
        margin: 12px 0 20px;
    `,
};
productDetailsPageStyles.wrapper = {
    css: css`
        ${layoutContainer}
        display: grid;
        grid-template-columns: minmax(0, auto) 317px;
        gap: 20px 22px;
    `,
};
productDetailsPageStyles.leftColumnWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 44px;
    `,
};
productDetailsPageStyles.leftColumn = {
    css: css`
        display: grid;
        grid-template-columns: 317px auto;
        gap: 22px;
    `,
};

productDetailsPageStyles.infoSkeleton = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        ${xScreen("lte", "md")} {
            margin-bottom: 20px;
        }
    `,
};

productDetailsPageStyles.actionsSkeleton = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 24px;
    `,
};
productDetailsPageStyles.actionsSkeletonItem = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};
productDetailsPageStyles.imageAndActionsSkeletonContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 44px;
    `,
};
productDetailsPageStyles.imageAndActionsSkeleton = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 317px) auto;
        gap: 22px;
        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
        }
    `,
};
productDetailsPageStyles.specificationsSkeleton = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};
